import { render } from "./WbCard.vue?vue&type=template&id=ac50ada6"
import script from "./WbCard.vue?vue&type=script&lang=js"
export * from "./WbCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__